import { useState } from "react";
import PatientSelector from "../components/PatientSelector";
import ProfileCollection from "../components/ProfileCollection";
import "../styles/patienthub.css";
import TopBar from "../components/topbar";

export default function PatientHub() {

  const [patient, setPatient] = useState(null);
  const [graphMode, setGraphMode] = useState("single");

  return (
    <>
      <TopBar
        graphMode={graphMode}
        setGraphMode={setGraphMode}
        patient={patient}
      />

      <div className="patienthub-container">

        <aside className="sidebar">
          <PatientSelector onSelect={setPatient} />
        </aside>

        <main className="main-dashboard">

          <ProfileCollection
            patient={patient}
            graphMode={graphMode}
          />

        </main>


      </div>
    </>
  );
}

